import { render, staticRenderFns } from "./TransExp.vue?vue&type=template&id=52d8948c&scoped=true&"
import script from "./TransExp.vue?vue&type=script&lang=js&"
export * from "./TransExp.vue?vue&type=script&lang=js&"
import style0 from "./TransExp.vue?vue&type=style&index=0&id=52d8948c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8948c",
  null
  
)

export default component.exports